import '@visma-swno/gaia-chat-ui';
import React, {useEffect, useRef} from "react";
import "./ai_assistant.scss";
import {Sparkles} from 'lucide-react';
import {useSelector} from "react-redux";
import * as reduxSelectors from "components/store/application.reducers.js";
import * as Api from "utils/api/api.js";
import {ICON_SIZE} from "components/common/constants";

const ASSISTANT_LANGUAGES = ['en', 'no', 'sv', 'da'];

export const AiAssistantConnect = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const assistantRef = useRef(null);
    const userLang = useSelector(reduxSelectors.getLanguage);
    const selectedLanguage = ASSISTANT_LANGUAGES.includes(userLang) ? userLang : 'en';
    const userData = useSelector(reduxSelectors.getUsersData);

    useEffect(() => {
        if (!assistantRef.current) return;

        const onClose = () => setIsOpen(false);
        assistantRef.current.addEventListener('close-requested', onClose);
        return () => assistantRef.current?.removeEventListener('close-requested', onClose);
    }, [isOpen]);

    useEffect(() => {
        if (assistantRef.current) {
            assistantRef.current.tokenProvider = async () => {
                try {
                    return (await Api.getTokenWithScope(["vsn-assistant-api:chat"])).access_token;
                } catch (error) {
                    console.error("Failed to get token for AI Assistant:", error);
                    return null;
                }
            }

            assistantRef.current.hostContextProvider = async () => {
                return {
                    state: {
                        userRole: userData?.userRoles?.systemAdministrator ? "admin" : "approver",
                        language: selectedLanguage
                    },
                    props: {
                        customerId: userData?.currentCompany?.idCustomer,
                        companyId:  userData?.currentCompany?.id
                    }
                };
            };
        }
    }, [userData, userLang, selectedLanguage]);

    return (
        <li className="icon">
            <a href={"#assistant"} data-testid={"open-assistant"} onClick={() => {
                setIsOpen(!isOpen)
            }}>
                <Sparkles id="chat-trigger" aria-label="AI Assistant" className="ai-assistant-icon"
                          size={ICON_SIZE.MEDIUM}/>
            </a>
            <aside id="popover-wrapper" data-testid={"popover-wrapper"} style={{display: isOpen ? 'block' : 'none'}}
                   aria-label="Assistant">
                <gaia-chat
                    ref={assistantRef}
                    id="chat-component"
                    data-testid={"chat-component"}
                    profile-id={window.ENVIRONMENT.NAME === "prod" ? "approval-prod" : "approval-stag"}
                    auth-strategy={"visma"}
                    base-url={window.ENVIRONMENT.AI_ASSISTANT_BASE_URL}
                    closeable
                    lang={selectedLanguage}/>
            </aside>
        </li>
    )

}

export default AiAssistantConnect;

